var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImpresso(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    viewBox: "0 0 506 506",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E3E3"
    },
    d: "M373,456h37.6c3.6,0,3.2-6,3.2-9.6V47.6c0-3.6,0.4-3.6-3.2-3.6H103.4c-3.6,0-9.6,0-9.6,3.6v33.6 L373,456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E3E3"
    },
    d: "M419,420h35.6c3.6,0,3.2-10,3.2-13.6V11.6c0-3.6,0.4-7.6-3.2-7.6H147.4c-3.6,0-9.6,4-9.6,7.6V44 L419,420z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4EFEF"
    },
    d: "M369.8,493.6c0,3.6-2.8,6.4-6.4,6.4H56.6c-3.6,0-6.4-2.8-6.4-6.4V90.4c0-3.6,2.8-6.4,6.4-6.4h306.8 c3.6,0,6.4,2.8,6.4,6.4V493.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.8,
    y: 124,
    style: {
      fill: "#AEB1B4"
    },
    width: 256,
    height: 80
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.8,
    y: 364,
    style: {
      fill: "#7D8B95"
    },
    width: 96,
    height: 96
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M257.8,242h-176c-2.4,0-4-1.6-4-4s1.6-4,4-4h176c2.4,0,4,1.6,4,4S260.2,242,257.8,242z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M257.8,274h-176c-2.4,0-4-1.6-4-4s1.6-4,4-4h176c2.4,0,4,1.6,4,4S260.2,274,257.8,274z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M257.8,306h-176c-2.4,0-4-1.6-4-4s1.6-4,4-4h176c2.4,0,4,1.6,4,4S260.2,306,257.8,306z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M257.8,338h-176c-2.4,0-4-1.6-4-4s1.6-4,4-4h176c2.4,0,4,1.6,4,4S260.2,338,257.8,338z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M337.8,370h-120c-2.4,0-4-1.6-4-4s1.6-4,4-4h120c2.4,0,4,1.6,4,4S340.2,370,337.8,370z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M337.8,402h-120c-2.4,0-4-1.6-4-4s1.6-4,4-4h120c2.4,0,4,1.6,4,4S340.2,402,337.8,402z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M337.8,434h-120c-2.4,0-4-1.6-4-4s1.6-4,4-4h120c2.4,0,4,1.6,4,4S340.2,434,337.8,434z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M337.8,466h-120c-2.4,0-4-1.6-4-4s1.6-4,4-4h120c2.4,0,4,1.6,4,4S340.2,466,337.8,466z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M337.8,242h-52c-2.4,0-4-1.6-4-4s1.6-4,4-4h52c2.4,0,4,1.6,4,4S340.2,242,337.8,242z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M337.8,274h-52c-2.4,0-4-1.6-4-4s1.6-4,4-4h52c2.4,0,4,1.6,4,4S340.2,274,337.8,274z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M337.8,306h-52c-2.4,0-4-1.6-4-4s1.6-4,4-4h52c2.4,0,4,1.6,4,4S340.2,306,337.8,306z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M337.8,338h-52c-2.4,0-4-1.6-4-4s1.6-4,4-4h52c2.4,0,4,1.6,4,4S340.2,338,337.8,338z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M361.4,506H54.6c-6,0-10.4-4.8-10.4-10.4V92.4c0-6,4.8-10.4,10.4-10.4h306.8c6,0,10.4,4.8,10.4,10.4v402.8 C371.8,501.2,367,506,361.4,506z M54.2,90c-1.2,0-2.4,1.2-2.4,2.4v402.8c0,1.2,1.2,2.4,2.4,2.4H361c1.2,0,2.4-1.2,2.4-2.4V92.4 c0-1.2-1.2-2.4-2.4-2.4H54.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M335.8,210h-256c-2.4,0-4-1.6-4-4v-80c0-2.4,1.6-4,4-4h256c2.4,0,4,1.6,4,4v80C339.8,208.4,338.2,210,335.8,210z M83.8,202 h248v-72h-248V202z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M179.8,466h-96c-2.4,0-4-1.6-4-4v-96c0-2.4,1.6-4,4-4h96c2.4,0,4,1.6,4,4v96C183.8,464.4,182.2,466,179.8,466z M87.8,458h88 v-88h-88V458z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M407.4,462h-37.6c-2.4,0-4-1.6-4-4s1.6-4,4-4h37.6c1.2,0,2.4-1.2,2.4-2.4V48.4c0-1.2-1.2-2.4-2.4-2.4H100.6 c-1.2,0-2.4,1.2-2.4,2.4V84c0,2.4-1.6,4-4,4s-4-1.6-4-4V48.4c0-6,4.8-10.4,10.4-10.4h306.8c6,0,10.4,4.8,10.4,10.4v402.8 C417.8,457.2,413,462,407.4,462z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M451.4,424h-37.6c-2.4,0-4-1.6-4-4s1.6-4,4-4h37.6c1.2,0,2.4-1.2,2.4-2.4V10.4c0-1.2-1.2-2.4-2.4-2.4H144.6 c-1.2,0-2.4,1.2-2.4,2.4V38c0,2.4-1.6,4-4,4s-4-1.6-4-4V10.4c0-6,4.8-10.4,10.4-10.4h306.8c6,0,10.4,4.8,10.4,10.4v402.8 C461.8,419.2,457,424,451.4,424z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpresso);
export default __webpack_public_path__ + "static/media/impresso.6d8b3eb5e64bb4c6ba9bcf8bc6f99be6.svg";
export { ForwardRef as ReactComponent };